<div class="h-full">
  <router-outlet></router-outlet> <router-outlet name="print"></router-outlet>
  <pc-cookiebar class="print:hidden" *ngIf="isCookieBarVisible()"></pc-cookiebar>
</div>
